"use client";

import { ContentComponents } from "@/components/pages/contentSections";

export default function DynamicContent({ content, page }) {
  if (!content?.length) return null;

  const pageType = page.__typename;

  return content.map((item, index) => {
    const Component = ContentComponents[item.__typename];
    if (!Component) return null;

    // Only apply extra margin between two image columns
    const nextItem = content[index + 1];

    let isImageColumnAndNextItemIsImageColumn = false;
    let isJustTextColumn = false;
    let isColumnRowAndNeedsMoreSpacingBottom = false;

    if (item.columns && nextItem && nextItem?.columns) {
      isImageColumnAndNextItemIsImageColumn =
        item.columns.some(
          (column) => column.__typename === "ImagecolumnRecord"
        ) &&
        nextItem.columns.some(
          (column) => column.__typename === "ImagecolumnRecord"
        );
    }

    if (item.columns && nextItem) {
      const nextItemIsSectionLineFromCMS =
        item.columns.some(
          (column) => column.__typename === "ImagecolumnRecord"
        ) && nextItem.__typename === "SectionlineRecord";

      isColumnRowAndNeedsMoreSpacingBottom = nextItemIsSectionLineFromCMS;
    }

    // TODO: Maybe only for image rows
    const isFinalCMSItemOnServicepage =
      pageType === "ServiceRecord" && index === content.length - 1;

    if (!isColumnRowAndNeedsMoreSpacingBottom) {
      isColumnRowAndNeedsMoreSpacingBottom = isFinalCMSItemOnServicepage;
    }

    isJustTextColumn =
      item?.columns &&
      // Strip empty columns
      item.columns
        .filter((column) => column.__typename !== "EmptycolumnRecord")
        .every((column) => column.__typename === "TextcolumnRecord");

    // Redundant I think...
    if (!item.data) {
      item.data = { ...item };
    }

    return (
      <Component
        isImageColumnAndNextItemIsImageColumn={
          isImageColumnAndNextItemIsImageColumn
        }
        isJustTextColumn={isJustTextColumn}
        isColumnRowAndNeedsMoreSpacingBottom={
          isColumnRowAndNeedsMoreSpacingBottom
        }
        key={index}
        data={item.data}
        {...page}
      />
    );
  });
}
